import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'

interface Props {
  size: 'small' | 'medium'
}

function TriplePointTakeoverTierIcon(props: Props) {
  const { size } = props

  const [tier] = useCurrentLoyaltyTier()
  return <LoyaltyTierIcon size={size === 'small' ? 22 : 40} tier={tier} />
}

export default TriplePointTakeoverTierIcon
